import { FC, useMemo, useState } from "react";
import { GetRubricatedBooksListServiceResponse, PostDownloadRubricatedBookEntryParams, PostDownloadRubricatedBookResponse, RubricatedBook } from "../../../../../shared/interfaces/services/rubricated-books";
import { RowSize } from "../../../../../shared/components";
import { ActionButton } from "@hdi-seguros/web-components.action-button";
import { Table } from "antd";
import ProductionService from "../../../../../shared/services/production";
import { BINARY_VALUES, BOOLEAN_VALUES } from "../../../../../shared/interfaces";
import { BOOK_TYPES } from "../../../../../shared/interfaces";
import { downloadBase64Files } from "../../../../../shared/utils";
import { FILE_TYPES } from "../../../../../shared/interfaces";

interface RubricatedBooksTableProps {
    rubricatedBooksList: GetRubricatedBooksListServiceResponse;
    isLoading: boolean;
}

export const RubricatedBooksTable: FC<RubricatedBooksTableProps> = ({ rubricatedBooksList, isLoading }) => {
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(12);
    
    const downloadRubricatedBookFile = async (
        { anio, mes, quincena }: RubricatedBook,
        excel: string,
        tipoLibro: string
    ) => {
        const month = String(mes).padStart(2, '0');
        const yearMonth = `${anio}-${month}`;
        const type = excel === BOOLEAN_VALUES.TRUE ? FILE_TYPES.XLSX : FILE_TYPES.ZIP;
        const [fechaDesde, fechaHasta] = quincena === BINARY_VALUES.ONE
            ? [`${yearMonth}-01`, `${yearMonth}-15`]
            : [`${yearMonth}-16`, `${yearMonth}-30`];

        const entryParams: PostDownloadRubricatedBookEntryParams = {
            fechaDesde,
            fechaHasta,
            excel,
            tipoLibro
        };
        
        const fileResponse: PostDownloadRubricatedBookResponse = await ProductionService.postDownloadRubricatedBook(entryParams);
        downloadBase64Files(fileResponse.fileEncoded, fileResponse.fileName, type);
    };
    
    
    const HEADERS_PRELIQUIDATIONS_TABLE = useMemo(() => [
        {
            title: 'Quincena',
            dataIndex: 'descripcion',
            key: 'string',
        },
        {
            title: 'Registros de Operaciones',
            key: 'actions',
            render: (record: RubricatedBook) => (
                <>  
                    {
                        <RowSize rowProps={{ align: 'middle', justify: 'space-evenly' }}>    
                            <ActionButton 
                                label="Excel" 
                                onClick={() => downloadRubricatedBookFile(record, BOOLEAN_VALUES.TRUE, BOOK_TYPES.OPERACIONES)}
                                type="text"
                                textColor="green-3"
                                style={{fontWeight: "bold"}}
                            />
                                    
                            <ActionButton 
                                label="XML" 
                                textColor="green-9"
                                type="text"
                                style={{fontWeight: "bold"}}
                                onClick={() => downloadRubricatedBookFile(record,  BOOLEAN_VALUES.FALSE, BOOK_TYPES.OPERACIONES)}
                            />
                        </RowSize>
                    }
                </>
            )
        },
        {
            title: 'Registros de Cobranzas',
            key: 'actions',
            render: (record: RubricatedBook) => (
                <>  
                    {
                        <RowSize rowProps={{ justify: 'space-evenly' }}>    
                            <ActionButton 
                                label="Excel" 
                                onClick={() => downloadRubricatedBookFile(record, BOOLEAN_VALUES.TRUE, BOOK_TYPES.COBRANZAS)}
                                type="text"
                                textColor="green-9"
                                style={{fontWeight: "bold"}}
                            />
                                    
                            <ActionButton 
                                label="XML" 
                                textColor="green-3"
                                type="text"
                                onClick={() => downloadRubricatedBookFile(record, BOOLEAN_VALUES.FALSE, BOOK_TYPES.COBRANZAS)}
                                style={{fontWeight: "bold"}}
                            />
                        </RowSize>
                    }
                </>
            )
        },
            
        ], [
    ]);
    
    return (
        <Table
            loading={isLoading}
            bordered
            className='w-100'
            columns={HEADERS_PRELIQUIDATIONS_TABLE}
            dataSource={
                rubricatedBooksList.registros
            }
            pagination={{
                current: currentPage,
                pageSize: pageSize,
                showTotal: (total) =>
                    total === 1 ? 'Una quincena' : `${total} quincenas`,
                total: rubricatedBooksList.registros?.length,
                showSizeChanger: true,
                pageSizeOptions: ['12', '24', '48', '96'],
                onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setPageSize(pageSize);
                  },
            }}
            rowKey={(record) => `${record.anio}-${record.mes}-${record.quincena}`}
        />
    );
}